var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFiles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C14.3438 12 13 13.3438 13 15V25C13 26.6562 14.3438 28 16 28H25H26C26.5531 28 27 27.5531 27 27C27 26.4469 26.5531 26 26 26V24C26.5531 24 27 23.5531 27 23V13C27 12.4469 26.5531 12 26 12H25H16ZM16 24H24V26H16C15.4469 26 15 25.5531 15 25Cnan nan 15.4469 24 16 24ZM17 16.5C17 16.225 17.225 16 17.5 16H23.5C23.775 16 24 16.225 24 16.5Cnan nan 23.775 17 23.5 17H17.5C17.225 17 17 16.775 17 16.5ZM17.5 18H23.5C23.775 18 24 18.225 24 18.5Cnan nan 23.775 19 23.5 19H17.5C17.225 19 17 18.775 17 18.5Cnan nan 17.225 18 17.5 18Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFiles);
export default __webpack_public_path__ + "static/media/ic_files.7c9d89e104fe715c6390fdc450cf38e4.svg";
export { ForwardRef as ReactComponent };